import { MsalProvider } from "@azure/msal-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { msalInstance } from "./authentication/msalConfig";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import PowerApp from "./routes/apps";
import Page from "./routes/page";
import App from "./routes/root";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App></App>,
  },
  {
    path: "apps/:appName",
    element: <PowerApp />,
  },
  {
    path: "page/:id",
    element: <Page></Page>,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// export const baseUrl = "http://localhost:1337";
export const baseUrl = "https://portaalcms.adite.be";

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-R2LFCPEDS5"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-R2LFCPEDS5');
          `}
        </script>
      </Helmet>
      {/* Your app components */}
    </HelmetProvider>
    <MsalProvider instance={msalInstance}>
      <RouterProvider router={router} />
      {/* <App /> */}
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
